import { AppRouter } from 'marionette';

let Router = AppRouter.extend({
  appRoutes: {
    'register.php(?)(form_name=:formName)': 'onRoute',
  },
});

export default class RegisterRouter extends Router {}
